import { getScriptData } from './utils.m.js';
const { resizeHelperUrl } = getScriptData(import.meta.url, true);

if (!window.resizeHelper) {
	window.resizeHelper = new JJK.ResizeHelper();
	window.resizeHelper.init(resizeHelperUrl);
}
